import { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { imageActions } from '../constants';

const fetchImages = withDraft((draft, action) => {
  action.items.forEach(({ code }) => {
    const item = findMatch(draft.images, code);
    if (item) {
      item.readStatus = states.PENDING;
      item.readErrors = [];
    } else {
      draft.images.push({ code, readStatus: states.PENDING, readErrors: [] });
    }
  });
});

const showImageSuccess = withDraft((draft, action) => {
  action.items.forEach(({ code }) => {
    const item = findMatch(draft.images, code);
    item.readStatus = states.SUCCESS;
    item.readErrors = [];
  });
});

const showImageError = withDraft((draft, action) => {
  action.items.forEach(({ code, error }) => {
    const item = findMatch(draft.images, code);
    item.readStatus = states.ERROR;
    item.readErrors = [error];
  });
});

export default {
  [imageActions.FETCH_IMAGES]: fetchImages,
  [imageActions.SHOW_IMAGE_ERROR]: showImageError,
  [imageActions.SHOW_IMAGE_SUCCESS]: showImageSuccess,
};
